module.exports = __webpack_public_path__ + "media/images/user/disclaimers/icon_down-7d2997bb2c2775df053518095283e4a4.png";